import { ShareAdapter } from "./ShareAdapter";
export class WhatsappShareAdapter extends ShareAdapter {
    doShare(data) {
        const href = 'whatsapp://send?text=' + encodeURIComponent(data.url + data.title);
        window.open(href);
    }
}
